<template>
  <g>
    <g clip-path="url(#clip0_15_675)">
      <path
        d="M18 0.000244141H6C4.34 0.000244141 3 1.34024 3 3.00024V21.0002C3 22.6602 4.34 24.0002 6 24.0002H18C19.66 24.0002 21 22.6602 21 21.0002V3.00024C21 1.34024 19.66 0.000244141 18 0.000244141ZM13.5 22.0002H10.5C10.22 22.0002 10 21.7802 10 21.5002C10 21.2202 10.22 21.0002 10.5 21.0002H13.5C13.78 21.0002 14 21.2202 14 21.5002C14 21.7802 13.78 22.0002 13.5 22.0002ZM19.25 19.0002H4.75V3.00024H19.25V19.0002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_675">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
